import './Separator.scss';

export const Separator = () => {
  return <div className='section-separator' />;
};

export default Separator;
